'use client'

import { MenuItem } from '@/models/menu.model'
import React, { ReactNode, useState } from 'react'

interface TabWrapperProps {
  categories: MenuItem | MenuItem[] // Nhận một category hoặc mảng categories
  onTabChange?: (slug: string) => void
  children: (activeTab: string) => ReactNode // Định nghĩa `children` là một function
}

const TabWrapper: React.FC<TabWrapperProps> = ({ categories, onTabChange, children }) => {
  const isSingleCategory = !Array.isArray(categories)
  const categoryList = isSingleCategory ? [categories] : categories

  const [activeTab, setActiveTab] = useState(categoryList[0]?.slug || '')

  const handleTabClick = (slug: string) => {
    setActiveTab(slug)
    onTabChange?.(slug)
  }

  return (
    <div>
      {/* Tabs */}
      <div className="flex items-center space-x-4 pb-4">
        {categoryList.map((category) => (
          <React.Fragment key={category.id}>
            <div
              className={`relative cursor-pointer font-semibold transition ${
                activeTab === category.slug
                  ? 'text-black text-[18px]'
                  : 'text-textGray hover:text-black'
              }`}
              onClick={() => handleTabClick(category.slug)}
            >
              {category.name}
              {activeTab === category.slug && (
                <span className="absolute left-0 right-0 bottom-[-2px] h-[3px] bg-primary" />
              )}
            </div>

            {category.childCategories?.map((child) => (
              <div
                key={child.id}
                className={`relative cursor-pointer font-semibold transition ${
                  activeTab === child.slug
                    ? 'text-black text-[18px]'
                    : 'text-textGray hover:text-black text-[14px]'
                }`}
                onClick={() => handleTabClick(child.slug)}
              >
                {child.name}
                {activeTab === child.slug && (
                  <span className="absolute left-0 right-0 bottom-[-2px] h-[3px] bg-primary" />
                )}
              </div>
            ))}
          </React.Fragment>
        ))}
      </div>

      {/* Content */}
      <>{children(activeTab)}</>
    </div>
  )
}

export default TabWrapper
